<template>
    <md-app md-mode="fixed">
        <md-app-toolbar class="md-primary" v-if="loaded">
            <img v-if="location.picture" class="logo logo--bar" :src="location.picture" alt="">
            <span v-if="!location.picture">{{location.name}}</span>

            <md-button class="tab" :class="{'tab--active' : this.$router.currentRoute.name === 'dashboard'}"
                       @click="goToPage('dashboard')">
                <span>Dashboard</span>
            </md-button>

            <md-button class="tab" :class="{'tab--active' : this.$router.currentRoute.name === 'products'}"
                       @click="goToPage('products')">
                <span>Produkte</span>
            </md-button>

            <md-button class="tab" :class="{'tab--active' : this.$router.currentRoute.name === 'settings'}"
                       @click="goToPage('settings')">
                <span>Einstellungen</span>
            </md-button>

            <div class="md-toolbar-section-end">
                <md-button class="md-icon-button" @click="exit">
                    <md-icon>exit_to_app</md-icon>
                </md-button>
            </div>
        </md-app-toolbar>

        <slot></slot>
    </md-app>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import store from 'store'

    export default {
        name: "Layout",
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('dashboard', [
                'loaded',
                'location'
            ]),
            ...mapGetters('notification', [
                'error'
            ]),
        },
        mounted() {
            this.$material.locale = this.locale
            this.loadLocation(this.user.locationId)
        },
        methods: {
            ...mapActions('auth', [
                'logout'
            ]),
            ...mapActions('dashboard', [
                'loadLocation'
            ]),
            exit: function () {
                this.logout()
                store.remove('user')
                this.$router.push('/login')
            },
            goToPage: function (name) {
                this.$router.push({name: name})
            }
        },
        watch: {
            error: function (val) {
                if (val && val.response.status == 401) {
                    this.exit();
                }
            }
        }

    }
</script>
